import React from "react";

import { CategoryConnectionEdge, Post } from "interfaces/wordpress";
import Card from "components/the-buzz-theme/card/card";

const lexemes = {
  titleScreenReader: "Articles by Category",
  titleListScreenReader: " Articles",
  ctaTextScreenReader: "View more",
  ctaTextExtraScreenReader: " articles",
};

export type Props = {
  edge: CategoryConnectionEdge;
  categoryKey: number;
  activeIndex: number;
};

export default function CategoryTabsItem({
  edge,
  categoryKey,
  activeIndex,
}: Props) {
  const id = categoryKey + 1;
  const node = edge?.node;

  const [isOpen, setIsOpen] = React.useState(false);
  const [isShowing, setIsShowing] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(categoryKey === activeIndex);
    setTimeout(() => {
      setIsShowing(categoryKey === activeIndex);
    }, 250);
  }, [categoryKey, activeIndex]);

  return (
    <div
      id={`cat-${id}`}
      className={`tab-pane fade ${isOpen ? "active" : ""} ${isShowing ? "show" : ""}`}
      role="tabpanel"
      aria-labelledby={`cat${id}-tab`}
      style={{
        backgroundColor: node.categoryPageFields?.categoryColor || undefined,
      }}
      key={`tab-pane-${categoryKey}`}
    >
      <div className="desktop-container post-loop-container">
        <div className="tab-wrapper row row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
          {node.posts?.nodes &&
            node.posts.nodes
              .filter((_node, index) => index < 4)
              // @ts-ignore
              .map((post: Post, postKey: number) => (
                <Card post={post || undefined} key={postKey} />
              ))}
        </div>
      </div>

      <div className="category-link view-more-wrap white">
        <a
          className="view-more-btn more-btn btn btn-outline-primary"
          role="button"
          href={`/the-buzz/${node.slug}`}
        >
          {lexemes.ctaTextScreenReader}
          <span className="screen-reader-text">{node?.name}</span>
          {lexemes.ctaTextExtraScreenReader}
        </a>
      </div>
    </div>
  );
}

export { CategoryTabsItem };
